import React, {Component} from 'react';
import HomePageBody from '../../../components/Home/HomePageBody/HomePageBody';

class HomePageBodyContainer extends Component {


  render() {
    return (
      <HomePageBody
        sendMessage={this.props.sendMessage}
        messageSuccess={this.props.messageSuccess}
      />
    )
  }
}

export default (HomePageBodyContainer);



// WEBPACK FOOTER //
// ./src/containers/Home/HomePageBody/HomePageBody.js